import React, { useState, useEffect } from 'react';
import RenderCategories from './RenderCategories';
import ListPlaceholder from './loaders/ListPlaceholder';
import RenderPdfSummary from './RenderPdfSummary';

function RenderResults({ results, forPDF, totalScannedElements }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (results && Object.keys(results).length > 0) {
      setLoading(false);
    }
  }, [results]);

  if (loading) {
    return <ListPlaceholder className="w-100 h-100" />;
  }

  if (!results || Object.keys(results).length === 0) {
    return null;
  }

  const totalCount = Object.values(results)
    .filter(cat =>
      ['Errors', 'Contrast Errors', 'Alerts'].includes(cat.description)
    )
    .reduce((acc, cat) => acc + (cat.count || 0), 0);

  return (
    <>
      {/* PDF rezime na vrhu samo kada exportujemo */}
      {forPDF && <RenderPdfSummary results={results} totalCount={totalCount} totalScannedElements={totalScannedElements} />}

      {Object.keys(results).map((category) => {
        const categoryData = results[category];
        const description = categoryData.description;

        // U PDF režimu prikazujemo samo Errors i Alerts
        if (forPDF && description !== 'Errors' && description !== 'Alerts') {
          return null;
        }

        // Inače prikazuj sve ove
        if (
          description === 'Errors' ||
          description === 'Contrast Errors' ||
          description === 'Alerts' ||
          description === 'ARIA' ||
          description === 'Features'
        ) {
          return (
            <RenderCategories
              key={description}
              categoryName={category}
              categoryData={categoryData}
              forPDF={forPDF}
            />
          );
        }

        return null;
      })}
    </>
  );
}

export default RenderResults;
